import React, { Component } from 'react';
import { Flex, Button, Dropdown } from 'monday-ui-react-core';
import { Heading } from "monday-ui-react-core/next";
import classes from "./settings.module.scss";
import { showNotice } from '../../services/error-handling';
import { searchWorkspacesByName } from '../../services/api-service';
import mondaySdk from "monday-sdk-js";
import { fetchSettings, saveSettings } from '../../services/backend-service';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workspaceId: null,
      workspaceName: null,
      workspaces: [],
      loadingOnSave: false,
      isLoading: true,
      isAdmin: false
    };
  }

  componentDidMount() {
    const monday = mondaySdk();

    const loadSettings = async() => {
      await this.fetchWorkspaces("");
      await this.fetchSettings();
    }

    monday.listen("context", (res) => {
      this.setState({
        isAdmin: res.data.user.isAdmin,
      });

      loadSettings();
    });
  }

  async save() {
    if(this.state.workspaceId === null) {
      showNotice("error", "Please select a backup workspace");
      return;
    }

    this.setState({ 
      loadingOnSave: true
    });

    const settings = {
      backupWorkspaceId: this.state.workspaceId
    }

    await saveSettings(settings);

    this.setState({ 
      loadingOnSave: false
    });
    showNotice("success", "Settings saved successfully");
  }

  async fetchWorkspaces(searchString) {
    const data = await searchWorkspacesByName(searchString);
    let results = [];
    data.forEach((workspace) => {
      results.push({
        label: workspace.name,
        value: workspace.id
      });
    })

    this.setState({
      workspaces: results,
      isLoading: false
    });
  }

  async fetchSettings() {
    const data = await fetchSettings();
    let workspaceName = null;

    if(data.backupWorkspaceId) {
      this.state.workspaces.forEach((workspace) => {
        if(workspace.value === data.backupWorkspaceId) {
          workspaceName = workspace.label;
        }
      })
      this.setState({
        workspaceId: data.backupWorkspaceId,
        workspaceName: workspaceName
      });
    }
  }

  render() {
    return (
      <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.container}>
        <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
          <Heading className={classes.sectionHeading} type={Heading.types.H2}>Global settings</Heading>
        </Flex>
        <div className={classes.formTitle}>Snapshot workspace</div>
        <Dropdown 
          className={classes.fullWidth}
          isLoading={this.state.isLoading}
          value={ {label: this.state.workspaceName, value: this.state.workspaceId} }
          onInputChange={(newValue) => {
            this.setState({
              isLoading: true
            });
            this.fetchWorkspaces(newValue);
          }}
          onChange={(e) => { 
            this.setState({ 
              workspaceName: e ? e.label : null,
              workspaceId: e ? e.value : null
            }); 
          }}
          options={this.state.workspaces} 
        />
        <div className={classes.subtitle}>Will be used to store backup snapshots. Workspace should be dedicated for backup operations and not used for anything else. It's not recommended to change the workspace once set as all existing snapshots will be unaccessible.<br/>Dropdown will display up to 20 workspaces, but you may search for additional ones.</div>
        <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
          <Button 
            size={Button.sizes.SMALL} 
            kind={Button.kinds.PRIMARY}
            loading={this.state.loadingOnSave}
            disabled={this.state.loadingOnSave}
            onClick={() => {
              this.save();
            }}
          >
            Save
          </Button>
        </Flex>
      </Flex>
    );
  }
}

export default Settings;
